module.exports = __webpack_public_path__ + "img/24.5.COD.58f30010.png";